/**
 * 3-Layer-Filter-Logik für Webtrainer-NG.
 *
 * Layer 1 (immer sichtbar): Burning-Topic-Chips + LF-Multi + Modus + Suche
 * Layer 2 (Disclosure): Tag, Card-Type, Source
 * Layer 3 (implicit): FSRS-Due (in WebtrainerStore.filteredDueIds)
 *
 * Pure functions — kein State.
 */
import { BURNING_TOPICS, type BurningTopic } from '$types/burning-topics';
import type { Card } from '$types/card';

export function matchesBurningTopic(card: Card, topic: BurningTopic): boolean {
  const haystack = [...card.tags, card.id].join(' ').toLowerCase();
  return topic.tagPatterns.some((p) => haystack.includes(p.toLowerCase()));
}

export function cardsForBurningTopics(cards: readonly Card[], topicIds: readonly string[]): Card[] {
  if (!topicIds.length) return [...cards];
  const topics = BURNING_TOPICS.filter((t) => topicIds.includes(t.id));
  return cards.filter((c) => topics.some((t) => matchesBurningTopic(c, t)));
}

export function uniqueDecks(cards: readonly Card[]): string[] {
  return [...new Set(cards.map((c) => c.deck))].sort();
}

export function uniqueTags(cards: readonly Card[]): string[] {
  const set = new Set<string>();
  for (const c of cards) for (const t of c.tags) set.add(t);
  return [...set].sort();
}

export function uniqueCardTypes(cards: readonly Card[]): string[] {
  return [...new Set(cards.map((c) => c.type))].sort();
}

export function uniqueSources(cards: readonly Card[]): string[] {
  const set = new Set<string>();
  for (const c of cards) if (c.source) set.add(c.source);
  return [...set].sort();
}

export function countCardsByBurningTopic(cards: readonly Card[]): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const t of BURNING_TOPICS) {
    counts[t.id] = cards.filter((c) => matchesBurningTopic(c, t)).length;
  }
  return counts;
}
